<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="transparent-toolbar">
        <ion-buttons slot="start">
          <ion-button @click="goTo('/dosen')">
            <ion-icon :icon="arrowBackOutline" color="dark"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="welcome-title">Manajemen <span class="highlight">Dosen</span></ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding dashboard-container">
      <div class="header-action glass-effect ion-margin-bottom">
        <div>
          <h3>Data Dosen</h3>
          <p>Total: {{ dosens.length }} dosen</p>
        </div>
        <button class="btn-primary" @click="showAddModal = true">
          <ion-icon :icon="addOutline"></ion-icon> Tambah
        </button>
      </div>

      <div class="table-container glass-effect">
        <table class="report-table">
          <thead>
            <tr>
              <th>NIDN</th>
              <th>Nama Dosen</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="dosens.length === 0">
              <td colspan="3" class="ion-text-center" style="padding: 20px;">Belum ada data.</td>
            </tr>
            <tr v-for="dosen in dosens" :key="dosen.id">
              <td>{{ dosen.nidn }}</td>
              <td>{{ dosen.nama }}</td>
              <td>
                <button class="btn-danger" @click="deleteDosen(dosen.id)">Hapus</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Tambah Dosen -->
      <div class="modal-overlay" v-if="showAddModal">
        <div class="modal-content glass-effect">
          <div class="modal-header">
            <h3>Tambah Dosen Baru</h3>
            <ion-icon :icon="closeOutline" @click="showAddModal = false" class="close-icon"></ion-icon>
          </div>
          
          <div class="form-group">
            <label>NIDN / Username</label>
            <input type="text" v-model="newDosen.nidn" class="custom-input" placeholder="Masukkan NIDN" />
          </div>
          <div class="form-group">
            <label>Nama Dosen</label>
            <input type="text" v-model="newDosen.nama" class="custom-input" placeholder="Nama Lengkap" />
          </div>
          <div class="form-group">
            <label>Password Default</label>
            <input type="text" v-model="newDosen.password" class="custom-input" readonly />
            <small style="color: #666; margin-top: 5px; display: block;">*Password dapat diubah oleh dosen nantinya</small>
          </div>

          <button class="btn-primary" @click="addDosen" style="width: 100%; margin-top: 15px;">
            Simpan Data
          </button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { 
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon
} from '@ionic/vue';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { 
  arrowBackOutline, addOutline, closeOutline 
} from 'ionicons/icons';
import { db } from '../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc, serverTimestamp, orderBy, query } from 'firebase/firestore';

export default {
  name: 'DosenManajemen',
  components: {
    IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon
  },
  setup() {
    const router = useRouter();
    const dosens = ref([]);
    const showAddModal = ref(false);
    
    const newDosen = ref({
      nidn: '',
      nama: '',
      password: 'dosen123'
    });

    const loadDosen = async () => {
      try {
        const q = query(collection(db, "dosen"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const data = [];
        snapshot.forEach(doc => {
          data.push({ id: doc.id, ...doc.data() });
        });
        dosens.value = data;
      } catch (err) {
        console.error(err);
      }
    };

    onMounted(() => {
      const role = localStorage.getItem('user_role');
      if (role !== 'admin') {
        alert('Akses Ditolak! Hanya Admin yang boleh mengelola data dosen.');
        router.replace('/dosen');
        return;
      }
      loadDosen();
    });

    const addDosen = async () => {
      if (!newDosen.value.nidn || !newDosen.value.nama) {
        alert('Lengkapi NIDN dan Nama Dosen!');
        return;
      }
      try {
        await addDoc(collection(db, "dosen"), {
          nidn: newDosen.value.nidn,
          nama: newDosen.value.nama,
          password: newDosen.value.password,
          createdAt: serverTimestamp()
        });
        showAddModal.value = false;
        newDosen.value = { nidn: '', nama: '', password: 'dosen123' };
        loadDosen();
      } catch (err) {
        alert('Gagal menambah dosen: ' + err.message);
      }
    };

    const deleteDosen = async (id) => {
      if (confirm('Yakin ingin menghapus dosen ini?')) {
        try {
          await deleteDoc(doc(db, "dosen", id));
          loadDosen();
        } catch (err) {
          alert('Gagal menghapus dosen: ' + err.message);
        }
      }
    };

    const goTo = (path) => {
      router.push(path).catch(() => { window.location.href = path; });
      setTimeout(() => { if (window.location.pathname !== path) window.location.href = path; }, 100);
    };

    return {
      goTo,
      arrowBackOutline,
      addOutline,
      closeOutline,
      dosens,
      showAddModal,
      newDosen,
      addDosen,
      deleteDosen
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

* {
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
}

.dashboard-container {
  --background: #fdfdfd;
}

.transparent-toolbar {
  --background: transparent;
  padding: 10px 0;
}

.welcome-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1f1f1f;
}

.highlight {
  color: #fca311;
}

.header-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 20px;
}

.header-action h3 {
  margin: 0 0 5px 0;
  font-weight: 600;
  font-size: 1.1rem;
}

.header-action p {
  margin: 0;
  font-size: 0.85rem;
  color: #666;
}

.btn-primary {
  background: #1f1f1f;
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

.btn-danger {
  background: #ffe5e5;
  color: #e53935;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.8rem;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.05);
}

.table-container {
  border-radius: 15px;
  overflow: hidden;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.report-table th {
  background: rgba(252, 163, 17, 0.1);
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #1f1f1f;
  border-bottom: 2px solid rgba(252, 163, 17, 0.3);
}

.report-table td {
  padding: 12px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  color: #555;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  width: 90%;
  max-width: 400px;
  border-radius: 20px;
  padding: 25px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
}

.close-icon {
  font-size: 24px;
  color: #666;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
}

.custom-input {
  width: 100%;
  padding: 12px 15px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
  background: #f9f9f9;
  outline: none;
}
</style>
